import { TheirStackJobsProvider } from "./modal/TheirStackJobsContext";
import TheirStackJobsBody from "./TheirStackJobsBody";

interface Props {
  isAdmin: boolean;
}

export default function TheirStackJobsPage({ isAdmin }: Props) {
  return (
    <TheirStackJobsProvider isAdmin={isAdmin}>
      <TheirStackJobsBody />
    </TheirStackJobsProvider>
  );
}
